import React from 'react';

const KPICard = ({ label, value, sub, gradient, accentColor, icon }) => (
  <div className="dashboard-card p-6 relative overflow-hidden slide-in-up">
    <div
      className="absolute right-0 top-0 h-full w-24"
      style={{ background: `linear-gradient(to left, ${accentColor}1a, transparent)` }}
    />
    <div className="flex items-center">
      <div className="rounded-full p-3 mr-4 shadow-lg flex-shrink-0" style={{ background: gradient }}>
        {icon}
      </div>
      <div>
        <p className="text-gray-500 text-sm font-medium">{label}</p>
        <div className="flex items-baseline">
          <p className="text-3xl font-bold text-gray-800">{value ?? '—'}</p>
        </div>
        {sub && <p className="text-xs text-gray-400 mt-1">{sub}</p>}
      </div>
    </div>
  </div>
);

const WeeklyKPICards = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="dashboard-card p-6 animate-pulse h-28" />
        ))}
      </div>
    );
  }

  const sum = (key) => data.reduce((acc, r) => acc + (r[key] || 0), 0);

  const totalScreening = sum('screeningCalls');
  const totalPassed = sum('passedAfterScreening');
  const totalFinals = sum('finalStages');
  const totalAccepted = sum('offersAccepted');
  const totalOffers = sum('totalOffers');

  const acceptRate = totalOffers > 0 ? Math.round((totalAccepted / totalOffers) * 100) : null;
  const convRate = totalScreening > 0 ? Math.round((totalPassed / totalScreening) * 100) : null;

  const acceptRateColor =
    acceptRate !== null && acceptRate >= 75
      ? '#10b981'
      : acceptRate !== null && acceptRate >= 50
      ? '#f59e0b'
      : '#ef4444';

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
      <KPICard
        label="Screening Calls"
        value={totalScreening}
        sub={convRate !== null ? `${convRate}% pass rate` : null}
        gradient="linear-gradient(135deg, #4841F0 0%, #3730c8 100%)"
        accentColor="#4841F0"
        icon={
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
        }
      />
      <KPICard
        label="Passed Screening"
        value={totalPassed}
        gradient="linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"
        accentColor="#6366f1"
        icon={
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }
      />
      <KPICard
        label="Final Stages"
        value={totalFinals}
        gradient="linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)"
        accentColor="#8b5cf6"
        icon={
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        }
      />
      <KPICard
        label="Offers Accepted"
        value={totalAccepted}
        gradient="linear-gradient(135deg, #10b981 0%, #059669 100%)"
        accentColor="#10b981"
        icon={
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        }
      />
      <KPICard
        label="Offer Accept Rate"
        value={acceptRate !== null ? `${acceptRate}%` : '—'}
        sub={`${totalAccepted} of ${totalOffers} offers`}
        gradient={`linear-gradient(135deg, ${acceptRateColor} 0%, ${acceptRateColor}cc 100%)`}
        accentColor={acceptRateColor}
        icon={
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        }
      />
    </div>
  );
};

export default WeeklyKPICards;
